import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { GlobalResponse, User } from '@app/shared-module/models';
import { Constants } from '../constants';
import { CommonService } from '../common-service.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SidebarComponent implements OnInit {

  user: User = {} as User;
  @Output() navToggle = new EventEmitter();
  navLarge = false;

  activeIndex = -1;
  navList: any[] = [];
  constructor(
    private router: Router,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    if (localStorage.getItem('internallogin')) {
      this.user = JSON.parse(localStorage.getItem('internallogin'));
      // console.log(this.user);
    }
    const subscriptionList = {
      name: 'Subscription',
      icon: 'fa fa-link',
      open: false,
      url: '/doctor/subscription',
      links: [],
      imgPath: '../../../assets/images/admin/subscriptionBlue.png'
    };
    const repayment = {
      name: 'Repayment',
      icon: 'fa fa-bell',
      open: false,
      url: '/admin/repayment',
      links: [],
      imgPath: '../../../assets/images/admin/Repayment.png'
    };

    const transactionDashboard = {
      name: 'Transaction Dashboard',
      icon: 'fa fa-credit-card',
      open: false,
      url: '/admin/transactionDashboard',
      links: [],
      imgPath: '../../../assets/images/admin/TranDash.png'
    };

    const transactionList = {
      name: 'Transaction List',
      icon: 'fa fa-list',
      open: false,
      url: '/admin/transaction',
      links: [],
      imgPath: '../../../assets/images/admin/TranList.png'
    };

    const inventory = {
      name: 'Inventory',
      icon: 'fa fa-list',
      open: false,
      url: '/inventory/dashboard',
      links: [],
      imgPath: '../../../assets/images/admin/Inventory.png'
    };

    const manageUser = {
      name: 'Manage User',
      icon: 'fa fa-list',
      open: false,
      url: '/admin/manageUser',
      links: [],
      imgPath: '../../../assets/images/admin/User.png'
    };

    const doctorLead = {
      name: 'Doctor Lead',
      icon: 'fa fa-list',
      open: false,
      url: '/doctor/lead',
      links: [],
      imgPath: '../../../assets/images/admin/doctor.png'
    };

    this.navList.push(subscriptionList);
    if (this.user && this.user.role) {
      if (this.user.role === Constants.ROLE_ADMIN) {
        this.navList.push(manageUser);
        this.navList.push(doctorLead);
        this.navList.push(repayment);
        this.navList.push(transactionDashboard);
        this.navList.push(transactionList);
        this.navList.push(inventory);
      } else if (this.user.role === Constants.ROLE_OPERATIONS) {
        this.navList.push(manageUser);
        this.navList.push(doctorLead);
      } else if (this.user.role === Constants.ROLE_ACCOUNTS) {
        this.navList.push(doctorLead);
        this.navList.push(repayment);
        this.navList.push(transactionDashboard);
        this.navList.push(transactionList);
      } else if (this.user.role === Constants.ROLE_MARKETING) {
        this.navList.push(doctorLead);
        this.navList.push(repayment);
        this.navList.push(transactionDashboard);
        this.navList.push(transactionList);
        this.navList.push(inventory);
      }
    }
  }

  // onChangePassword = () => {
  //   this.router.navigate([Constants.CHANGE_PASSWORD_URL]);
  // }

  logout = () => {
    localStorage.removeItem('internallogin');
    localStorage.removeItem('token');
    this.commonService.logOut().subscribe((res: GlobalResponse) => {
      if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
        this.router.navigate([Constants.ADMIN_LOGIN_URL]);
      }
    });
  }

  // onProfile = () => {
  //   this.router.navigate([Constants.PROFILE_DASHBOARD_URL]);
  // }
  // =============================================================================================


  toggleNav() {
    this.navLarge = !this.navLarge;
    this.navToggle.emit(this.navLarge);
  }

}
